import AnswerThree from "containers/DigitalWallet/AnswerThree"

export const airtime_faq = [
    {
        id: 1,
        question: 'Can I Set Up Auto-Recharge For My Airtime On Poucher?',
        answer: 'Yes, you can set up an auto-recharge for your airtime on Poucher. This feature allows you to automatically recharge your airtime at a specified time interval without having to initiate the process manually every time.'
    },
    {
        id: 2,
        question: 'Is It Possible To Buy Airtime For Another Network On Poucher?',
        answer: `Yes, it is possible to buy airtime for another network on Poucher. All you need to do is select the appropriate network and input the recipient's phone number.`
    },
    {
        id: 3,
        question: 'How Can I Check My Airtime Balance After Recharging On Poucher?',
        answer: 'You can check your airtime balance after recharging on Poucher by dialing the appropriate code for your network. The code can be found on the Poucher website or by contacting your network provider.'
    },
    {
        id: 4,
        question: 'Can I Get A Refund For Airtime I Mistakenly Bought On Poucher?',
        answer: 'No, unfortunately, Poucher does not offer refunds for airtime purchases made in error. It is important to double-check the phone number and network before completing the transaction.'
    },
]

export const data_faq = [
    {
        id: 1,
        question: 'How Secure Is It To Purchase Data Plans On Poucher For Nigerian Networks?',
        answer: 'Purchasing data plans on Poucher is highly secure. We use the latest encryption technology to protect your personal and financial information, ensuring that your transactions are safe and secure.'
    },
    {
        id: 2,
        question: 'Can I Purchase Data Plans On Poucher Using My Debit Card?',
        answer: `Yes, you can purchase data plans on Poucher using your debit card. We accept payment through various payment methods, including debit cards, bank transfers, and our digital wallets.`
    },
    {
        id: 3,
        question: 'How Quickly Will I Receive My Purchased Data Plan On Poucher?',
        answer: 'Once you have completed your purchase on Poucher, you will receive your data plan almost instantly. In some cases, it may take a few minutes to activate.'
    },
    {
        id: 4,
        question: 'Is It Possible To Purchase Data Plans On Poucher For Multiple Network Providers At Once?',
        answer: 'Yes, you can purchase data plans for multiple network providers on Poucher. Simply select the network provider and the desired data plan for each provider, and complete your purchase.'
    },
    {
        id: 5,
        question: 'How Can I Check My Data Balance After Purchasing A Data Plan On Poucher?',
        answer: `To check your data balance after purchasing a data plan on Poucher, simply dial the appropriate USSD code for your network provider or use the provider's mobile app.`
    }
]

export const cable_faq = [
    {
        id: 1,
        question: 'Can I Pay For My Dstv Subscription Online?',
        answer: 'Yes, you can pay for your DStv subscription online—through Poucher. Simply select the DStv subscription package you want, and complete the payment process.'
    },
    {
        id: 2,
        question: 'What Dstv Subscription Packages Are Available On Poucher?',
        answer: `Poucher offers a wide range of DStv subscription packages to choose from, including the DStv Premium, Compact Plus, Compact, Family, and Access packages.`
    },
    {
        id: 3,
        question: 'Can I Pay For My Gotv Subscription On Poucher?',
        answer: 'Yes, you can pay for your GOtv subscription on Poucher by selecting the GOtv subscription package you want and following the prompts to complete the payment process.'
    },
    {
        id: 4,
        question: 'What Gotv Subscription Packages Are Available On Poucher?',
        answer: 'Poucher offers a variety of GOtv subscription packages to choose from, including GOtv Max, GOtv Jolli, GOtv Jinja, GOtv Lite, and more.'
    },
    {
        id: 5,
        question: 'How Do I Pay For My Subscription On Showmax?',
        answer: `You can pay for your Showmax subscription on Poucher by selecting the Showmax subscription package you want and following the prompts to complete the payment process.`
    },
    {
        id: 6,
        question: 'Is It Possible To Pay For My Dstv Subscription With Poucher If I Am Outside Nigeria?',
        answer: `Yes, you can pay for your DStv subscription with Poucher even if you are outside Nigeria, as long as you have an active Poucher account and a valid payment method.`
    }
]

export const betting_faq = [
    {
        id: 1,
        question: 'How Quickly Will My Betting Account Be Funded After Using Pouchers To Make A Deposit?',
        answer: 'Your account will be funded instantly once the transaction is completed on Pouchers.'
    },
    {
        id: 2,
        question: 'Can I Use Pouchers To Fund My Betting Account From Anywhere In Nigeria?',
        answer: `Yes, Pouchers is available and accessible from anywhere in Nigeria, making it a convenient option for online betting enthusiasts.`
    },
    {
        id: 3,
        question: 'Are There Any Fees Or Charges For Using Pouchers To Fund My Betting Account?',
        answer: 'Yes, there is a little charge, which will be specified on the funding page.'
    },
    {
        id: 4,
        question: 'Can I Fund My Betting Account With Pouchers Using Any Payment Method?',
        answer: 'Yes, Pouchers supports various payment methods, vouchers, including debit cards, bank transfers, and online wallets.'
    },
    {
        id: 5,
        question: 'Are There Any Limits On How Much I Can Deposit Into My Betting Account Using Pouchers?',
        answer: `The maximum amount you can deposit into your betting account using Pouchers may vary depending on the platform you are funding and your KYC level. `
    }
]

export const voucher_faq = [
    {
        id: 1,
        question: 'How To Purchase A Payment Voucher On Pouchers',
        steps: [
            'Create an account or log in on Pouchers',
            'Select the "Vouchers" option from the menu',
            'Then, select "Buy Vouchers"',
            'Choose the voucher amount you want to purchase',
            `Complete the payment with your preferred payment method. If you aren’t logged in on Pouchers, you can pay with either debit card or bank account. If you’re logged in, you'll pay from your Pouchers wallet.`,
            'Once you complete the payment process, an alphanumeric 10-DIGIT PIN will be generated and sent to your email address. This PIN is your voucher code, which can be redeemed on the Pouchers platform.'
        ]
    },
    {
        id: 2,
        question: 'How To Redeem A Payment Voucher On Pouchers',
        steps: [
            'Create an account or log in on Pouchers with only a face ID',
            'Select the "Vouchers" option from the menu',
            'Select "Redeem Voucher"',
            'Enter your voucher code in the space provided.',
            'The voucher amount will be added to your wallet, which you can use to make payments or purchase other vouchers.'
        ]
    },
    {
        id: 3,
        question: 'How To Gift Someone A Voucher On Pouchers',
        steps: [
            'Create an account or log in on Pouchers with only a face ID',
            'Select the "Gift Voucher" option.',
            `Enter the recipient's email address.`,
            'They will receive an email with the voucher code and instructions on how to redeem it.',
            'To redeem the voucher, the recipient can go to the "Redeem Voucher" section on the Poucher app or website and enter the voucher code.',
            'The voucher amount will then be added to their wallet for use towards purchases.'
        ]
    },
    {
        id: 4,
        question: 'What Payment Options Are Available For Purchasing Vouchers On Poucher?',
        answer: 'Pouchers supports various payment options including debit/credit cards, bank transfers, and USSD codes.'
    }
]


export const dollar_faq = [
    {
        id: 1,
        question: 'Can I Use My Naira Wallet Balance To Fund My USD Virtual Card?',
        answer: 'Yes, you can use your Naira wallet balance to fund your USD virtual card on Pouchers. Check Pouchers NGN to USD conversion rate for funding your USD card.'
    },
    {
        id: 2,
        question: 'What Is The Difference Between A Virtual Dollar Card And A Regular Dollar Card?',
        answer: `A virtual dollar card is a digital card that is created and used for online transactions only. On the other hand, a regular dollar card is a physical card that can be used for both online and offline transactions.`
    },
    {
        id: 3,
        question: 'Are There Any Fees Associated With Creating A Virtual Card On Pouchers?',
        answer: 'Yes, there is a small creation fee associated with creating a virtual card on Pouchers. The fee varies depending on the type of card you are creating.'
    },
    {
        id: 4,
        question: 'Can I Use My Virtual Card For International Transactions?',
        answer: 'Yes, you can use your virtual card for international transactions as long as the merchant or service accepts virtual cards as a payment method.'
    },
    {
        id: 5,
        question: 'How Do I View My Transaction History On My Virtual Card?',
        answer: `To view your transaction history on your virtual card, log in to your Pouchers account, navigate to the "Virtual Cards" section, select the card you want to view the transaction history for, and you will see all the transactions made with the card.`
    },
    {
        id: 6,
        question: 'Is It Possible To Freeze A Virtual Card On Pouchers?',
        answer: `Yes, it is possible to freeze a virtual card on Pouchers. Simply navigate to the "Virtual Cards" section on your account, select the card you want to freeze, and follow the prompts to do so.`
    },
    {
        id: 7,
        question: 'How To Create Virtual Cards On Pouchers',
        steps: [
            'Create an account or log in to your Pouchers account.',
            'Select the "Virtual Cards" feature on the dashboard.',
            'Select "USD Virtual Card"',
            // 'Select either "NGN Virtual Card" or "USD Virtual Card," depending on your preferred currency.',
            'Fill in the required information.',
            'Confirm the card creation fee.',
            'Click on "Create Card" to complete the process.'
        ]
    }
]
export const internet_faq = [
    {
        id: 1,
        question: 'Can I Pay For My Internet Subscription Online?',
        answer: 'Yes, you can pay for your internet subscription online — through Pouchers. Select your preferred internet subscription package, and complete the payment process.'
    },
    {
        id: 2,
        question: 'What Internet Subscription Packages Are Available On Pouchers?',
        answer: `Pouchers offers a wide range of internet subscription packages, including Spectranet, Smile, or Swift.`
    },
    {
        id: 3,
        question: 'Can I Pay For My Spectranet Subscription On Pouchers?',
        answer: 'Yes, you can pay for your Spectranet subscription on Pouchers by selecting the Spectranet subscription package you want and following the prompts to complete the payment process.'
    },
    {
        id: 4,
        question: 'How Do I Pay For My Subscription On Swift?',
        answer: 'You can pay for your Swift subscription on Pouchers by selecting the Swift subscription package you want, and following the prompts to complete the payment process.'
    },
    {
        id: 5,
        question: 'Is It Possible To Pay For Internet Subscription With Pouchers If I Am Outside Nigeria?',
        answer: `Yes, you can pay for your internet subscription with Pouchers even if you are outside Nigeria, as long as you have an active Pouchers account and a valid payment method`
    }
]
export const electricity_faq = [
    {
        id: 1,
        question: 'Can I Pay For My Prepaid Meter Online With Poucher?',
        answer: 'Yes, you can pay for your prepaid meter online with Poucher. Simply select the prepaid meter option, enter your meter number and input the amount you want to top up.'
    },
    {
        id: 2,
        question: 'How Long Does It Take For My Electricity Bill Payment To Be Processed?',
        answer: `Your electricity bill payment will be processed instantly as soon as you complete the transaction on Poucher.`
    },
    {
        id: 3,
        question: 'How Do I Load My Token?',
        answer: `First things first, ensure there’s power supply. To be precise, confirm that your meter’s phase has power on it. If you’re currently on generator, put it off and switch over to PHCN. Afterwards, punch in the token numbers and click “enter.”`
    },
    {
        id: 4,
        question: 'Why Can’t I Load My Token?',
        answer: `Check if you purchased a token for the correct meter number. Double check if possible. If the meter is a brand new meter, check if it has been activated. If it hasn’t been activated, you’ll need to get an activation code from the corresponding distribution company. If all else fails, contact our 24-hour support team on {…} or email us at {…}`
    },
    {
        id: 5,
        question: 'I’ve Been Debited But I’m Yet To Receive My Token?',
        answer: `It may be a network problem. If you don’t receive your token in at most (X)minutes, then you’ll get a full reversal of the debited amount within 24 hours. If all else fails, contact our 24-hour support team on… or email us at…`
    },
    {
        id: 6,
        question: 'I’ve Loaded My Token, But I Still Don’t Have Power Supply?',
        answer: `First, ensure you actually have power supply. Better still, confirm the phase you’re on has power supply. Switch over to PHCN if you’ve been on generator or inverter. `
    },
    {
        id: 7,
        question: 'Which Electricity Distribution Company Is Available on Pouchers?',
        steps: [
            'Abuja Electricity Distribution Company',
            'Benin Electricity Distribution Company',
            'Enugu Electricity Distribution Company',
            'Ibadan Electricity Distribution Company',
            'Jos Electricity Distribution Company',
            'Kaduna Electricity Distribution Company',
            'Kano Electricity Distribution Company',
            'Eko Electricity Distribution Company',
            'Ikeja Electricity Distribution Company',
            'Port Harcourt Electricity Distribution Company',
            'Yola Electricity Distribution Company'
        ]
    }
]

export const digital_wallet = [
    {
        id: 1,
        question: 'How Secure Is My Digital Wallet On Pouchers?',
        answer: 'Pouchers takes the security of your digital wallet seriously. We use industry-standard encryption protocols and work with reputable payment partners to ensure your funds are ALWAYS safe and secure. In addition, we offer multi-factor authentication and other security features to prevent unauthorized access to your wallet.'
    },
    {
        id: 2,
        question: 'Can I Transfer Funds From My Digital Wallet To Other E-Wallets Or Bank Accounts?',
        answer: `Yes, you can transfer funds from your digital wallet to other e-wallets or bank accounts. You can do this by adding your bank account or card to your Pouchers account and initiating a transfer within the app. Please note that fees may apply and transfer times may vary depending on the receiving bank or e-wallet.`
    },
    {
        id: 3,
        question: 'What Is The Maximum Amount I Can Keep In My Digital Wallet On Pouchers?',
        answer: <AnswerThree/>
    },
    {
        id: 4,
        question: 'Can I Use My Pouchers Digital Wallet To Receive Funds From Other Users Or External Sources?',
        answer: `Yes, you can receive funds in your digital wallet from other Pouchers users who send you money through the app. Additionally, you can also receive funds from external sources such as bank transfers or other payment platforms.`
    }
]